import React from 'react';
import classNames from 'classnames';

import { NamedLink } from '../../components';
import { getDeadlineStatus } from '../deadlines';

import css from './EigeneAnfrage.module.css';

/**
 * FairwayBid – die eigene Anfrage aus Sicht der Anlage.
 *
 * Auf der Anfrageseite stand bisher auch fuer den Eigentuemer der grosse
 * gruene Knopf "Angebot einreichen" – mit dem Hinweis darunter, dass es der
 * eigene Eintrag ist. Ein Knopf, der nichts tut, neben einem Satz, der
 * erklaert, warum er nichts tut: Das ist keine Information, das ist eine
 * Sackgasse.
 *
 * Stattdessen steht hier, was die Anlage an dieser Stelle wirklich wissen
 * will: laeuft die Frist noch, und wo liegen die Angebote. Der Weg zum
 * Bearbeiten steht ohnehin schon als Leiste ueber dem Titel.
 */
const EigeneAnfrage = props => {
  const { listing, className } = props;
  const frist = getDeadlineStatus(listing);
  const abgelaufen = frist?.expired;

  return (
    <div className={classNames(css.wurzel, className)}>
      <h3 className={css.titel}>
        {abgelaufen ? 'Die Angebotsfrist ist abgelaufen.' : 'Ihre Anfrage läuft.'}
      </h3>

      <p className={css.text}>
        {abgelaufen
          ? 'Es kommen keine neuen Angebote mehr herein. Eingegangene Angebote können Sie weiter vergleichen und vergeben; die Anfrage lässt sich jederzeit erneut veröffentlichen.'
          : 'Passende Anbieter sehen sie und reichen ihre Angebote hier ein. Sie bekommen jedes Angebot in den Posteingang und entscheiden allein, welches Sie annehmen.'}
      </p>

      {frist ? (
        <p className={classNames(css.frist, { [css.fristEng]: frist.urgent && !abgelaufen })}>
          {frist.label}
        </p>
      ) : null}

      <NamedLink name="InboxPage" params={{ tab: 'orders' }} className={css.link}>
        Angebote im Posteingang
      </NamedLink>
    </div>
  );
};

export default EigeneAnfrage;
